// [ API ]
export let BASE_URL = null
export const setBaseUrl = (url) => {
    BASE_URL = url;
};
export let FEATURE_FLAGS = null
export const setFeatureFlags = (flags) => {
    FEATURE_FLAGS = flags;
};

// Frontend paths
export const LOGIN_PATH = "/login"
export const DASHBOARD_PATH = "/dashboard"

// Routes
export const BASE_ROUTE = "/api"
export const AUTH_ROUTE = BASE_ROUTE + "/auth"
export const USERS_ROUTE = BASE_ROUTE + "/users"
export const POSTS_ROUTE = BASE_ROUTE + "/posts"
export const ALERTS_ROUTE = BASE_ROUTE + "/alerts"
export const CUSTOMERS_ROUTE = BASE_ROUTE + "/customers"
export const VEHICLES_ROUTE = BASE_ROUTE + "/vehicles"
export const DRIVERS_ROUTE = BASE_ROUTE + "/drivers"
export const CONTACTS_ROUTE = BASE_ROUTE + "/contacts"
export const ADDRESSES_ROUTE = BASE_ROUTE + "/addresses"
export const CARGO_ROUTE = BASE_ROUTE + "/cargo"
export const COMPANY_ROUTE = BASE_ROUTE + "/company"
export const FREIGHTS_ROUTE = BASE_ROUTE + "/freights"
export const AI_WORKSHOP_ROUTE = BASE_ROUTE + "/ai-workshop"
export const AI_AGENT_ROUTE = BASE_ROUTE + "/ai-agent"
export const HERE_MAPS_ROUTE = BASE_ROUTE + "/here-maps"
export const EMAIL_IMPORT_ROUTE = BASE_ROUTE + "/email-messages"

// Headers
export const HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    // "Accept": "application/json, text/plain, */*"
}

// [ COMMON ]
export const STANDARD_ROLE = "standard"
export const ADMIN_ROLE = "admin"
export const USER_ACTIVE = true
export const USER_NOT_CLOSED = false
export const USER_NOT_ACTIVE = false
export const MINIMUM_PASSWORD = "123456"
export const TEST_DOMAIN = "test.com"
export const TEST_EMAIL = "user@" + TEST_DOMAIN
export const STANDARD_EMAIL = STANDARD_ROLE + "@" + TEST_DOMAIN
export const ADMIN_EMAIL = ADMIN_ROLE + "@" + TEST_DOMAIN
